import {useEffect, useRef, useState} from "react";
import {SwalAlertClass} from "core/swalClass";

const RowTRComponentSwitch = ({
    fieldName,
    _TC,
    valueIn = 0,
    hasIn = false,
    updatedIn = false,
    deactivated = null,
    inputProps = {},
    noInput = false,
}) => {
    const Alert = new SwalAlertClass({confirmButtonText: _TC("button.accept")});
    const input = useRef(null);
    const [has, setHas] = useState(false);
    const [updated, setUpdated] = useState(false);
    const last = useRef(null);

    useEffect(() => {
        if (!noInput && input.current) {
            input.current.value = valueIn;
        }
        setHas(hasIn);
        setUpdated(updatedIn);
        last.current = valueIn;
    }, [hasIn, valueIn, updatedIn, noInput]);

    const changeHas = (e) => {
        setHas(e.target.checked);

        if (!input.current) return;

        if (!e.target.checked && deactivated) {
            last.current = input.current.value;
            input.current.value = deactivated;
        } else {
            input.current.value = last.current;
        }
    };

    const changeUpdated = (e) => {
        setUpdated(e.target.checked);
    };

    const onBlurParams = (e) => {
        if (!e.target.min && !e.target.max) return;
        const {title} = e.target;
        let value = parseInt(e.target.value);
        let min = parseInt(e.target.min);
        let max = parseInt(e.target.max);
        if (value < min || max < value) {
            Alert.warning(title, _TC("message.value.range").replace("{min}", min).replace("{max}", max));
            input.current.value = input.current.dataset.default;
            e.target.focus();
        }
    };

    return (
        <tr>
            <td>{_TC(`fields.${fieldName}`)}</td>
            <td>{_TC(`fields.${fieldName}.description`)}</td>
            <td>
                {noInput ? null : (
                    <div className="row">
                        <div className="col-md-8">
                            <div className="text-md-end mt-2">
                                <label htmlFor={fieldName} className="form-label">
                                    {_TC(`fields.${fieldName}.params`)}
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-center">
                            <input
                                ref={input}
                                type="number"
                                id={fieldName}
                                name={fieldName}
                                className="mb-2 form-control text-end"
                                title={_TC(`fields.${fieldName}`)}
                                defaultValue={valueIn}
                                onBlur={onBlurParams}
                                disabled={!has}
                                {...inputProps}
                            />
                        </div>
                    </div>
                )}
            </td>
            <td className="text-center-middle">
                <div className="form-switch">
                    <input
                        type="checkbox"
                        id={`has-${fieldName}`}
                        name={`has-${fieldName}`}
                        className="form-check-input"
                        checked={has}
                        onChange={changeHas}
                    />
                </div>
            </td>
            <td className="text-center-middle">
                <div className="form-switch">
                    <input
                        type="checkbox"
                        id={`updated-${fieldName}`}
                        name={`updated-${fieldName}`}
                        className="form-check-input"
                        checked={updated}
                        onChange={changeUpdated}
                    />
                </div>
            </td>
        </tr>
    );
};
export default RowTRComponentSwitch;
